import * as React from "react";

function SvgAdikteev(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 180 201"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <defs>
        <style>{".Adikteev_svg__cls-1{fill:#3c5066}"}</style>
      </defs>
      <g id="Adikteev_svg__Calque_2">
        <g id="Adikteev_svg__Calque_1-2">
          <g id="Adikteev_svg__lettre">
            <circle
              className="Adikteev_svg__cls-1"
              cx={88.7}
              cy={18.23}
              r={18.23}
            />
            <circle
              className="Adikteev_svg__cls-1"
              cx={157.97}
              cy={59.54}
              r={18.23}
            />
            <circle
              className="Adikteev_svg__cls-1"
              cx={157.97}
              cy={140.95}
              r={18.23}
            />
            <circle
              className="Adikteev_svg__cls-1"
              cx={88.7}
              cy={183.48}
              r={18.23}
            />
            <circle
              className="Adikteev_svg__cls-1"
              cx={18.23}
              cy={140.95}
              r={18.23}
            />
            <circle
              className="Adikteev_svg__cls-1"
              cx={18.23}
              cy={59.54}
              r={18.23}
            />
            <circle
              className="Adikteev_svg__cls-1"
              cx={88.7}
              cy={100.86}
              r={18.23}
            />
          </g>
          <path
            className="Adikteev_svg__cls-1"
            transform="rotate(-59.62 53.462 80.196)"
            d="M51.47 39.35h4v81.69h-4z"
          />
          <path
            className="Adikteev_svg__cls-1"
            transform="rotate(-30.81 123.336 80.197)"
            d="M83.01 78.2h80.65v4H83.01z"
          />
          <path className="Adikteev_svg__cls-1" d="M86.7 100.85h4v82.63h-4z" />
        </g>
      </g>
    </svg>
  );
}

export default React.forwardRef(SvgAdikteev);
